"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESET_QUES_DIFFICULTY = exports.REFRESH_WIKI = exports.REFRESH_MTV = void 0;
const client_1 = require("@apollo/client");
exports.REFRESH_MTV = (0, client_1.gql) `
  mutation RefreshMtv($name: String!) {
    admin {
      refreshMtv(name: $name)
    }
  }
`;
exports.REFRESH_WIKI = (0, client_1.gql) `
  mutation RefreshWiki($chapterIds: [Int]) {
    admin {
      refreshWiki(chapterIds: $chapterIds)
    }
  }
`;
exports.RESET_QUES_DIFFICULTY = (0, client_1.gql) `
  mutation ResetQueDifficulty {
    admin {
      resetQueDifficulty
    }
  }
`;
